export const FLOWTRACE_PUBLIC_APP_ID =
  "019f6339-d644-7943-8bba-8f54549de84b";

/** FlowTrace自身の記録に付けるリリース名。ビルドのコミットごとに変わる。 */
export const toFlowTraceSelfRelease = (build: string | undefined): string =>
  `flowtrace-dashboard@${build && /^[\w.-]{1,40}$/.test(build) ? build : "dev"}`;

export const isFlowTracePublicRecordingRoute = (pathname: string): boolean =>
  /^\/disclosures\/[^/]+\/?$/.test(pathname);

const APP_RECORDING_ROUTES = [
  /^\/$/,
  /^\/login\/?$/,
  /^\/mcp-access\/?$/,
  /^\/projects\/[^/]+\/?$/,
  /^\/sessions\/[^/]+\/[^/]+\/?$/,
];

/**
 * FlowTrace自身を記録する範囲。公開の開示ページと、ログイン〜ダッシュボード〜MCPアクセス。
 * デモは別のアプリIDで自分を記録するので含めない。
 */
export type FlowTraceSelfRecordingArea = "disclosure" | "app";

export const flowTraceSelfRecordingArea = (
  pathname: string,
): FlowTraceSelfRecordingArea | null => {
  if (isFlowTracePublicRecordingRoute(pathname)) return "disclosure";
  return APP_RECORDING_ROUTES.some((pattern) => pattern.test(pathname)) ? "app" : null;
};

/**
 * 記録に残すルート。セッションIDやアプリIDは別の顧客のデータを指すので、型に置き換える。
 */
export const toFlowTraceSelfRoute = (pathname: string): string => {
  if (/^\/sessions\//.test(pathname)) return "/sessions/:appId/:sessionId";
  if (/^\/projects\//.test(pathname)) return "/projects/:appId";
  if (/^\/disclosures\//.test(pathname)) return "/disclosures/:appId";
  return pathname;
};
